import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-165" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-166" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center text-3xl font-bold leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-167" data-mp="3fyvxs9ef7bak">
          What Teachers Are Saying
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-stone-600" data-id="element-168" data-mp="3ayqdjeahcr2i">
          <span aria-hidden="true" data-id="element-169" data-mp="370k767dk0di4">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +2,000 Teachers
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-2" data-id="element-170" data-mp="31z37ugapwz3n">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-xl border border-stone-200 bg-stone-50 p-6" data-id="element-171" data-mp="2x11pjxl493t8">
              <div className="text-sm text-amber-500" aria-label="5 out of 5 stars" data-id="element-172" data-mp="v8dl5kwqkabv">
                <span aria-hidden="true" data-id="element-173" data-mp="qb4zhacdpo5v">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-stone-800" data-id="element-174" data-mp="h559bys2ppvi">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-175" data-mp="780lluikxmcl">
                <p className="text-xs font-semibold text-stone-900" data-id="element-176" data-mp="79bnfosgsk12">
                  {item.name}
                </p>
                <p className="text-xs text-stone-500" data-id="element-177" data-mp="c8y0ny8am09v">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-stone-400" data-id="element-178" data-mp="14w29keaiayqx">
          Illustrative placeholder testimonials.
        </p>
      </div>
    </section>;
}